import axios from "axios";
import nprogress from "nprogress";
import "nprogress/nprogress.css";

import history from "./history";
import { deleteToken, getIdToken } from "../support/storage/BrowserStorage";

function logoutSystem() {
  deleteToken();
  history.push("/");
}

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

api.interceptors.request.use(
  async (options) => {
    nprogress.start();
    const token = getIdToken();

    if (options.headers != null) {
      options.headers.Authorization = `${token}`;
    }

    return options;
  },

  async (errorRequest) => {
    nprogress.done();
    return await Promise.reject(errorRequest);
  }
);

api.interceptors.response.use(
  (response) => {
    nprogress.done();
    return response;
  },
  async (error) => {
    nprogress.done();

    if (!error.response) {
      return await Promise.reject(error);
    }

    const {
      response: { status },
    } = error;

    if (status && status === 401) {
      logoutSystem();
    }

    return await Promise.reject(error);
  }
);

export { api };
